import { submitRedemptionForm, SubmitRedemptionFormApiParameter } from "@aspen/Services/AspenEmailService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";


type SubmitRedemptionFormParameter = {
    todayDate: string;
    emailRecipients: string;
    isRedemptionPage:string;
    emailTo?: string;
    npiNumber: string;
    firstName: string;
    lastName: string;
    specialty: string;
    areaOfInterest: string;
    practiceHospital: string;
    country: string;
    streetAddress: string;
    streetAddress2: string;
    city: string;
    state: string;
    zip: string;
    phone: string;
    email: string;
    serialNumbers: string;
    modelNumbers: string;
    invoiceNumbers: string;
    files: File[];
    physicianLicense: string;
    salesRepOrDistributor: string;
    additionalNotes: string;
    promotionToRedeem: string;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitRedemptionFormParameter, SubmitRedemptionFormApiParameter>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter =props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    await submitRedemptionForm(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitRedemption = createHandlerChainRunner(chain, "SubmitRedemption");
export default submitRedemption;
